const pt = {
    9000001: " 2023聖誕杯",
    9000002: "SuperEx合約錦標賽",
    9000003: "贏取30,000USDT競賽獎金",
    9000004: "参赛人数",
    9000005: "已解锁奖池（USDT）",
    9000006: "交易量排名资格赛",
    9000007: "盈利率排名資格賽",
    9000008: "盈利額排名資格賽",
    9000009: `交易量排名赛，解锁最高 <span style="color: #ffc72b;">20,000</span> USDT 奖金池`,
    9000010: "根據參賽人數解鎖對應獎池，參賽人數越多解鎖獎池越大，最高20,000USDT獎金池",
    9000011: "奖池金额",
    9000012: "活动期间每天10:00（UTC）更新",
    9000013: "獎勵預估",
    9000014: "期間纍計期貨交易金額",
    9000015: "奖励规则",
    9000016: "根据参赛人数解锁对应奖池，参赛人数越多解锁奖池越大，最高20,000U奖金池",
    9000017: "奖池金额（USDT）",
    9000018: "活动盈利率排名",
    9000019: "报名",
    9000020: "活动盈利额排名",
    9000021: "已结束",
    9000022: `盈利率排名賽，瓜分 <span style="color: #ffc72b;">{moneyPond}</span> USDT 獎金`,
    9000023: `盈利額排名賽，瓜分 <span style="color: #ffc72b;">{moneyPond}</span> USDT 獎金`,
    9000024: "累计合約盈利率",
    9000025: "纍計合约盈利金額",
    9000026: "未开始",
    9000027: "參賽用戶盈利額排名前50名獲得獎勵，可參考交易排名獎勵規則獲取贈金獎勵",
    9000028: "參賽用戶盈利率排名前50名可獲得獎勵，可參考交易排名獎勵規則獲取獎勵",
    9000029: "活動交易額排名",
    9000030: "",
 
    //交易合约积分
    9100001: 'Acumular Pontos',
    9100002: 'Receber Airdrop',
    9100003: 'Resgatar Recompensas',
    9100004: 'Saldo de pontos',
    9100005: 'Detalhes',
    9100006: 'Pontos de check-in',
    9100007: 'Pontos de Negócio',
    9100008: 'Pontos de convite',
    9100009: 'Pontos de Bônus',
    9100010: 'Sorteio de sorte',
    9100011: 'Obter pontos',
    9100012: 'Regras de Pontos',
    9100013: 'Detalhes dos pontos',
    9100014: 'Você precisa se registrar para participar deste evento. Clique para se registrar.',
    9100015: 'Negociou por {day} dias consecutivos e ganhou {num} pontos',
    9100016: 'Pontos ganhos hoje {num}',
    9100017: 'Prêmio de pontos',
    9100018: 'Cada sorteio consome {point} pontos，e o máximo de {num} sorteios por dia é permitido',
    9100019: 'Número de sorteios hoje',
    9100020: 'Usuário',
    9100021: 'Pontos',
    9100022: 'Saldo de pontos insuficiente',
    9100023: 'Saldo de pontos insuficiente. Por favor, obtenha pontos antes de participar do sorteio.',
    9100024: 'Número de sorteios atingiu o limite!',
    9100025: 'O número de sorteios hoje atingiu o limite. Tente novamente amanhã.',
    9100026: 'Como obter pontos',
    9100027: 'Registre-se para participar da atividade de negociação de futuros e ganhar pontos.',
    9100028: 'Inscrição bem-sucedida',
    9100029: 'Você se inscreveu para participar da atividade de negociação de contratos futuros para ganhar pontos. Vá negociar para ganhar mais pontos (você não terá mais direito a recompensas de comissão e cashback).',
    9100030: 'Após cancelar sua inscrição, você não receberá mais pontos. Tem certeza de que deseja cancelar sua inscrição?',
    9100031: 'Centro de Atividades de Pontos de Troca',
    9100032: 'Obter pontos',
    9100033: 'Você precisa se registrar para participar deste evento. Clique para se registrar.',
    9100034: 'Você pode ganhar pontos ao participar continuamente do contrato.',
    9100035: 'Os usuários podem ganhar pontos por todas as negociações de futuros.',
    9100036: 'Pontos de classificação',
    9100037: 'Os cinco principais usuários do ranking diário de negociações receberão pontos adicionais de bônus.',
    9100038: 'Usuários convidados recebem pontos e o convidador pode ganhar pontos bônus.',
    9100039: '{guy} Já ganhou<span style="color:#D9A31A"> {num} pontos!</span>',
    9100040: 'Participe do Sorteio Agora!',
    9100041: 'Parabéns por conseguir',
    9100042: 'Todos os tipos',
    9100043: 'Ficar nesta página',
    9100044: 'Inscreva-se para participar',
    9100045: 'Continuar negociando',
    9100046: 'No momento não há eventos em andamento. Fique atento para atualizações…',
    9100047: 'Acumule pontos, ganhe airdrops e troque-os por tokens SCS.',
    9100048: '',
    9100049: '',
 
    9100050: 'Datas',
    9100051: 'Selecionar data de início',
    9100052: 'Hora de término',
    9100053: 'a',
    9100054: 'Tipo',
 
    9100055: 'Pontos ganhos = volume de negociação * 1% (a dificuldade será ajustada conforme o volume total de negociações da plataforma aumenta).',
    9100056: 'Por exemplo: o usuário utiliza uma posição com margem de 100 USDT*100X=10000 USDT',
    9100057: 'Portanto, você só precisa de um depósito de 100 USDT para obter 100 pontos.',
    9100058: 'Os pontos de negociação são a única forma de obter o token da plataforma SCS.',
    9100059: 'Pontos bônus extras = total de pontos do dia * proporção de recompensa por classificação',
    9100060: 'Ranking',
    9100061: 'Primeiro lugar',
    9100062: 'Segundo lugar',
    9100063: 'Terceiro lugar',
    9100064: 'Quarto lugar',
    9100065: 'Quinto lugar',
    9100066: 'Usuários convidados recebem pontos e o convidador pode ganhar pontos bônus.',
    9100067: 'Fator de nível',
    9100068: 'Fórmula de cálculo: pontos de referência obtidos = pontos obtidos pelo convidado * coeficiente de nível',
    9100069: 'O coeficiente de nível será ajustado de acordo com a situação real',
    9100070: `Por exemplo: O usuário B participa de uma atividade de pontos, e seu convidador é o usuário A, e o número de convites do usuário A atingiu o Nível 3. O usuário B acumulou pontos = 360.000;`,
    9100071: 'Então, os pontos de promoção acumulados que o usuário A pode obter = 360.000 * 30% = 108.000',
    9100072: 'Coeficiente de recompensa',
    9100073: '1 usuário de negociação',
    9100074: 'O volume de negociação atinge 5 milhões',
    9100075: 'O volume de negociações atinge 20 milhões',
 
    9100076: 'Transferir',
 
    //热币
    9100080: 'Terminado',
    9100081: 'Clique em ‘Participar’ para ganhar prêmios',
    9100082: 'Ver Regras',
    9100083: 'Inscreva-se agora',
    9100084: 'Eventos',
    9100088: 'Ir para o trading',
    9100089: 'Depositar',
    9100090: 'Você já registrou isso  ',
    
    9100091: 'Este evento terminou, aguarde o próximo!',
    9100092: 'O evento ainda não começou, por favor, aguarde.',
    9100093: '',
    9100094: '',
 
    //api key
    9100105: 'Criar chave API',
    9100106: 'Ver Documentação da API',
    9100107: 'Sistema de negociação integrado',
    9100108: 'Criar/Gerir Chave API',
    9100109: 'Implantar API',
    9100110: 'Negociação e Pedidos',
    9100111: 'Uma plataforma de negociação de ativos digitais líder',
    9100112: 'Uma ampla variedade de serviços de negociação e gestão de ativos digitais para atender às diversas necessidades de negociação.',
    9100113: 'Oferecendo melhores serviços',
    9100114: 'Taxas de negociação mais favoráveis, valores de negociação mais altos, funções de gerenciamento de conta mais flexíveis, etc.',
    9100115: 'A escolha de milhões de usuários',
    9100116: 'Garantindo um ambiente de negociação seguro, oferecendo suporte profissional ao cliente, ajudando você a avançar de forma consistente no mundo dos ativos digitais.',
    9100117: 'Como criar uma chave API no SuperEx?',
    9100118: 'SuperEx 的 API 文档在哪里可以查看？',
    9100119: '在 SuperEx 交易发现了问题怎么办？',
    9100120: 'Onde posso ver a documentação da API da SuperEx?',
    9100121: 'Acesse a API SuperEx para negociações mais rápidas e suaves.',
    9100122: `Ao fazer login, passe o mouse sobre o avatar - 'Gerenciamento de API' e clique em 'Criar chave de API' para criar sua chave de API na SuperEx. Nota: Se você não estiver logado, precisará fazer login em sua conta SuperEx primeiro. Você também pode criar sua chave de API pelo link 'APIs' na barra de navegação inferior.`,
    9100123: 'Você pode clicar em<a style="color:#d1a53e">API文档</a>，para ver a documentação da API do SuperEx.',
    9100124: `Se você encontrar algum problema ou tiver sugestões durante o uso, pode entrar em contato conosco das seguintes maneiras: <br> entre em contato com o suporte através do "Centro de Ajuda" no site oficial ou enviando um e-mail para support@superex.com.`,
    9100125: `Para usar a API da SuperEx, você primeiro precisa:<br>
Registrar e fazer login na sua conta da SuperEx.<br> 
Criar uma chave de API, que gerará um access_key e um secret_key para você.<br>  
Utilizar este access_key e secret_key para assinar suas requisições.<br>
Dependendo das suas necessidades, você pode utilizar várias APIs fornecidas pela SuperEx, como a API de Dados de Mercado, API de Negociação e API de Conta. Certifique-se de que cada requisição siga as instruções na<br> documentação da API, com os cabeçalhos HTTP e assinaturas adequados.<br>`,
    9100126: 'Gestão',
    9100127: 'Criar nova chave de API',
    9100128: 'Nome da chave API',
    9100129: 'Insira um nome para a chave API  ',
    9100130: 'Configurações de Permissão',
    9100131: 'Ler',
    9100132: 'Trocar',
    9100133: 'Lista de IP permitidos (opcional)',
    9100134: 'Você pode vincular até 10 endereços IP a cada chave API, separados por vírgulas.',
    9100135: 'Li e concordo com',
    9100136: 'aviso de risco para usuários de API',
    9100137: 'Criar',
    9100138: `A SuperEx oferece uma API poderosa que permite o uso de serviços como consulta de mercado e negociação automática. Consulte a [Documentação da API] para saber como utilizá-la.`,
    9100139: 'Cada conta pode criar até 10 chaves API.',
    9100140: `Chaves de API que não estão vinculadas a um IP expirarão automaticamente após 90 dias. Se você pretende usá-las por um longo período, pode renová-las na seção 'Minhas Chaves de API' — 'Ação' — 'Renovar', estendendo o prazo de validade por mais 90 dias. Chaves de API vinculadas a IPs não têm limite de expiração.`,
    9100141: 'Minha Chave API',
    9100142: 'Permissões',
    9100143: 'Endereço IP',
    9100144: 'Renovar',
    9100145: 'Criar uma chave API requer que você deposite qualquer valor em sua carteira à vista para ativar sua conta.',
    9100146: 'Confirmar a renovação da chave API atual?',
    9100147: 'Não divulgue sua Access Key e Secret Key para evitar perda de ativos.',
    9100148: `Por razões de segurança, recomenda-se vincular chaves de API a endereços IP específicos. Uma chave de API pode ser vinculada a um máximo de 20 endereços IP ou segmentos de IP. Você pode inserir um único endereço IP ou vários endereços diretamente, separando-os com uma vírgula. Por exemplo: 192.168.1.1,192.168.1.2`,
    9100149: 'Após uma renovação bem-sucedida, a data de expiração será recalculada. Se você usar a Chave de API a longo prazo, recomenda-se vincular um endereço IP. As Chaves de API vinculadas não expirarão e também são mais seguras.',
    9100150: 'Confirmar a exclusão da chave API atual?',
    9100151: 'Você precisa entender os seguintes riscos:',
    9100152: `Sua Chave API está intimamente relacionada à segurança da sua conta. Qualquer pessoa que conheça sua Chave API pode potencialmente controlar os ativos da sua conta. Portanto, por favor, mantenha-a em segurança, não a divulgue a terceiros e não a carregue em sites ou fóruns de terceiros.`,
    9100153: `Se sua chave da API for vazada devido a motivos pessoais, incluindo, mas não se limitando a questões de segurança de ativos e perdas econômicas, você deve arcar com todas as responsabilidades decorrentes disso, e não assumiremos nenhuma responsabilidade.`,
    9100154: 'Aviso de Risco',
    9100155: 'Estou ciente e disposto a assumir o risco.',
    9100156: 'Salvo',
    9100157: 'Configurações de Permissão',
    9100158: 'A Chave Secreta é exibida apenas uma vez e não pode ser recuperada se perdida, por favor, mantenha-a em segurança.',
    9100159: 'Não divulgue sua Access Key e Secret Key para evitar perda de ativos.',
    9100160: 'Se você esquecer sua Chave Secreta, exclua este par de chaves e solicite um novo.',
    9100161: 'Oferecemos APIs poderosas para ajudá-lo a integrar recursos de negociação em seus aplicativos de forma eficiente. As APIs são categorizadas em Conta, Negociação e Dados de Mercado, permitindo que você configure as permissões necessárias e implemente negociação automatizada via API.',
    9100162: 'Data Criada',
    9100163: 'Criar nova chave de API',
    9100164: 'Editar',
    9100165: 'Data de Validade',
    9100166: 'Excluir',
    9100167: 'Criação bem-sucedida',
    9100168: 'Lembrete Amigável',
    9100169: 'Entendi',
    9100170: 'aviso de risco para usuários de API',
    9100171: 'Formato de IP incorreto',
    9100172: '',
    //自由区二维码分享页面
    9100095: 'SuperEx Mercado Livre, um mundo cripto dos usuários, pelos usuários, para os usuários.',
    9100096: 'Abrir o App',
    9100097: '',
    9100098: '',
 }
 export default pt
 


// WEBPACK FOOTER //
// ./src/i18n/langs/languageJame/pt.js